import * as React from "react"
import type { IconProps } from "../types"

const ChevronLeft = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14.9997 20L8.41391 13.4142C7.63286 12.6332 7.63286 11.3669 8.41391 10.5858L14.9997 4"
        />
      </svg>
    )
  }
)
ChevronLeft.displayName = "ChevronLeft"

export default ChevronLeft
